import React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class MarketplaceFees extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fees: props.formData,
    };

    this.addFee = this.addFee.bind(this);
    this.removeFee = this.removeFee.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onRecalculatePricesChange = this.onRecalculatePricesChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      fees: nextProps.formData,
    });
  }

  onChange(index, fieldName) {
    return (event) => {
      const newFees = this.state.fees;
      newFees[index][fieldName] = event.target.value;

      this.setState(
        {
          fees: newFees,
        },
        () => this.props.onChange(this.state.fees)
      );
    };
  }

  addFee() {
    this.setState(
      {
        fees: [
          ...this.state.fees,
          {
            orderTotal: '0',
            feePercentage: '25',
          },
        ],
      },
      () => this.props.onChange(this.state.fees)
    );
  }

  removeFee(index) {
    const newFees = this.state.fees;
    newFees.splice(index, 1);
    this.setState(
      {
        fees: newFees,
      },
      () => this.props.onChange(this.state.fees)
    );
  }

  onRecalculatePricesChange(index) {
    return () => {
      const newFees = this.state.fees;
      newFees[index]['recalculateItemPrices'] = !newFees[index]['recalculateItemPrices'];

      this.setState(
        {
          fees: newFees,
        },
        () => this.props.onChange(this.state.fees)
      );
    };
  }

  render() {
    return (
      <div>
        <legend>
          <FormattedMessage id={'marketplace.form.fees.legend'} />
        </legend>

        {this.state.fees.map((fee, index) => {
          return (
            <div key={index} className="marketplace-form__fees">
              <div className="row">
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'marketplace.form.field.fees.field.order.total.label'} />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder=""
                        type="text"
                        value={fee.orderTotal}
                        onChange={this.onChange(index, 'orderTotal')}
                      />
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'marketplace.form.field.fees.field.order.total.help'} />
                    </p>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'marketplace.form.field.fees.field.fee.percentage.label'} />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder=""
                        type="text"
                        value={fee.feePercentage}
                        onChange={this.onChange(index, 'feePercentage')}
                      />
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'marketplace.form.field.fees.field.fee.percentage.help'} />
                    </p>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group m-b-2">
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={fee.recalculateItemPrices}
                          onChange={this.onRecalculatePricesChange(index)}
                        />{' '}
                        <FormattedMessage id={'marketplace.form.field.fees.field.recalculate.prices.label'} />
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-right">
                <button onClick={() => this.removeFee(index)} className="btn btn-default btn-small">
                  <FormattedMessage id={'marketplace.form.field.fees.remove'} />
                </button>
              </div>
            </div>
          );
        })}

        <div className="marketplace-form__delivery-preferences-add m-b-1" onClick={this.addFee}>
          <small>
            <FontAwesomeIcon icon={faPlusCircle} /> <FormattedMessage id={'marketplace.form.field.fees.add'} />
          </small>
        </div>
      </div>
    );
  }
}

export default injectIntl(MarketplaceFees);
